// src/hooks/useGoogleMapsScript.ts
import { useEffect, useState } from 'react';

let loadingPromise: Promise<void> | null = null;

function loadScript(): Promise<void> {
  if (loadingPromise) return loadingPromise;
  loadingPromise = new Promise((resolve, reject) => {
    if ((window as unknown as { google?: unknown }).google) { resolve(); return; }
    const script = document.createElement('script');
    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Maps script'));
    document.head.appendChild(script);
  });
  return loadingPromise;
}

export function useGoogleMapsScript(): boolean {
  const [loaded, setLoaded] = useState(!!(window as unknown as { google?: unknown }).google);
  useEffect(() => {
    if (loaded) return;
    loadScript().then(() => setLoaded(true)).catch(() => setLoaded(false));
  }, [loaded]);
  return loaded;
}